import { Instance, types } from "mobx-state-tree"

// From rpc_schemas.VehicleStateSchema
export interface VehicleStateUpdate {
    id: number, 
    is_connected: boolean,
    is_in_service: boolean,
    is_parked: boolean,
    simulation_status: boolean | null
}


export enum VehicleStatus {
    Online = 'online',
    Offline = 'offline',
    OutOfService = 'outOfService',
}

export const VehicleStateModel = types.model('VehicleStateModel') 
.props({
    is_connected: types.boolean,
    is_in_service: types.boolean,
    is_parked: types.boolean,
    simulation_status: types.maybeNull(types.boolean),
})
.views((self) => ({
    get combinedState() {
        if (!self.is_in_service) 
            return VehicleStatus.OutOfService
        return self.is_connected ? VehicleStatus.Online : VehicleStatus.Offline
    },
    get isParked(): boolean {
        return self.is_parked
    },
    get isInService(): boolean {
        return self.is_in_service
    },
}))

export type VehicleState = Instance<typeof VehicleStateModel>